export default "__VITE_ASSET__1acbfad3__"